import React, { useEffect, useRef, lazy } from 'react';
export function FinalCTA() {
  const videoRef = useRef<HTMLIFrameElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Animation on scroll
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.1
    });
    const elements = document.querySelectorAll('.reveal, .reveal-up, .reveal-left, .reveal-right, .reveal-scale, .reveal-rotate, .reveal-blur, .animate-stagger-fade-in');
    elements.forEach(el => observer.observe(el));
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);
  return <div ref={sectionRef} className="relative py-16 overflow-hidden" data-id="element-54">
      {/* Enhanced gradient background with more dynamic animation */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#22c1c3] to-[#3a7bd5] animate-gradient" data-id="element-55"></div>
      {/* Enhanced background elements with premium animations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-56">
        <div className="absolute -top-32 -left-32 w-64 h-64 bg-white rounded-full opacity-10 animate-morph" data-id="element-57"></div>
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-white rounded-full opacity-5 animate-soft-bounce delay-500" data-id="element-58"></div>
        <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-white rounded-full opacity-10 animate-breathe delay-700" data-id="element-59"></div>
        {/* Additional premium background elements */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[150%] h-[150%] bg-gradient-to-r from-transparent via-white to-transparent opacity-5 animate-shimmer" data-id="element-60"></div>
        <div className="absolute bottom-1/4 right-1/4 w-48 h-48 bg-[#22c1c3] rounded-full opacity-10 animate-gentle-sway delay-1000" data-id="element-61"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-white text-center" data-id="element-62">
        {/* Enhanced main heading with 3D reveal */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 reveal-rotate" data-id="element-63">
          Ready to Stop the Damage?
        </h2>
        {/* Enhanced subheading with blur reveal */}
        <p className="text-lg md:text-xl mb-8 reveal-blur delay-200" data-id="element-64">
          Join thousands who have broken free from the cycle of migraines and
          reclaimed their comfort with proper nerve reset therapy.
        </p>
        {/* Main content with staggered reveal */}
        <div className="prose prose-invert max-w-none text-white/90 text-left md:text-center mb-10" data-id="element-65">
          <p className="mb-4 animate-stagger-fade-in stagger-0" data-id="element-66">
            I'm not going to insult you with fake urgency or manufactured
            scarcity.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-1" data-id="element-67">
            You've been in pain long enough to know when someone's playing
            games.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-2" data-id="element-68">
            Here's the truth:
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-3" data-id="element-69">
            Every day you wait is another day lost. Another event missed.
            Another apology made. Another handful of pills that solve nothing.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-4" data-id="element-70">
            The iRelief Oculis-3 comes with a 90-day guarantee because the
            makers know something most don't: Once you experience that first
            15-minute session — that first moment when the vise-grip releases —
            you'll understand what 12,000 of us already know.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-5" data-id="element-71">
            This isn't another treatment. It's your exit strategy.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-6" data-id="element-72">
            The trigeminovascular chain reaction that's been controlling your
            life? It has an off switch.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-7" data-id="element-73">
            You just haven't been shown where it is.
          </p>
          <p className="mb-4 animate-stagger-fade-in stagger-8" data-id="element-74">Until now.</p>
          <p className="italic font-light text-sm mb-4 animate-stagger-fade-in stagger-9" data-id="element-75">
            P.S. — If you're still reaching for pills every hour, you're already
            in the danger zone. Nerve damage can happen in as little as 3 months
            once the inflammation cycle starts. Don't wait.
          </p>
        </div>
        {/* Enhanced video container with premium shadow and reveal */}
        <div className="relative rounded-xl overflow-hidden shadow-2xl mb-4 mx-auto max-w-2xl reveal-scale delay-400 gradient-border" data-id="element-76">
          <iframe ref={videoRef} src="https://www.youtube.com/embed/PaMOLNppWM0?autoplay=1&mute=1&loop=1&controls=0&playlist=PaMOLNppWM0" title="iRelief Oculis Demo" className="w-full aspect-video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen frameBorder="0" loading="lazy" data-id="element-77"></iframe>
        </div>
        {/* Enhanced video caption with subtle animation */}
        <p className="text-sm text-white/80 italic mb-10 reveal-up delay-500 animate-pulse-slow" data-id="element-78">
          *This video demonstrates Oculis 1. The Oculis 3 includes additional
          features and improvements.
        </p>
        {/* Enhanced CTA Button with premium effects - UPDATED HREF */}
        <div className="mb-8 reveal-scale delay-600" data-id="element-79">
          <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" id="buy-now" className="inline-block bg-white text-[#3a7bd5] hover:bg-[#f8fafc] font-bold py-4 px-10 rounded-full transition-all duration-300 shadow-lg text-lg transform hover-shadow-grow btn-liquid animate-float-shadow" data-id="element-80">
            Try iRelief Oculis-3 Risk-Free for 90 Days
          </a>
        </div>
        {/* Enhanced guarantee badges with glow effect */}
        <div className="flex flex-wrap justify-center gap-4 mb-8 reveal-up delay-700" data-id="element-81">
          <div className="flex items-center text-sm animate-border-flow p-2 rounded-full" data-id="element-82">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 animate-pulse-slow" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-83">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-84" />
            </svg>
            1-Year Warranty | 90-Day Money Back Guarantee
          </div>
        </div>
        {/* Enhanced disclaimer text with fade in */}
        <p className="text-sm text-white/70 mb-12 reveal-up delay-800" data-id="element-85">
          This article contains affiliate links. We only recommend products that
          have helped thousands recover from migraine and headache symptoms.
          Results vary by individual.
        </p>
        {/* Enhanced P.P.S Section with premium glass effect */}
        <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-l-4 border-white reveal-scale delay-900 hover-bright backdrop-blur-transition" data-id="element-86">
          <p className="font-medium" data-id="element-87">
            <strong data-id="element-88">P.P.S.</strong> — If you're reading this with a migraine
            right now, I see you. It gets better. Not in some distant future. In
            about 15 minutes. That's a promise from someone who's been exactly
            where you are.
          </p>
        </div>
        {/* Enhanced legal disclaimers with subtle animation */}
        <div className="mt-10 text-xs text-white/70 reveal-blur delay-1000" data-id="element-89">
          <p className="mb-2" data-id="element-90">
            *Results may vary. In clinical studies, 87% of patients reported
            significant improvement in symptoms within 30 days of beginning
            regular heat therapy. Always consult with your healthcare
            professional before beginning any treatment regimen.
          </p>
          <p data-id="element-91">
            *These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
        </div>
      </div>
    </div>;
}